import React from 'react';

import { Icon, Stack, Text, VStack } from '@chakra-ui/react';
import { SearchX } from 'lucide-react';

import { FONTS_OPACITY } from '@/constant';

export const SearchEmptyState: React.FC = () => {
  return (
    <VStack
      flex={1}
      w='full'
      justify='center'
      align='center'
      gap={4}
      py={16}
      data-cy='global-search-empty'
    >
      <Icon as={SearchX} boxSize={8} color='glass-items.icon-hover' />
      <Stack gap={1} align='center' textAlign='center'>
        <Text fontSize='lg' fontWeight='semibold' color='fonts.primary'>
          We couldn’t find a match...
        </Text>
        <Text
          fontSize='sm'
          lineHeight='5'
          color='fonts.primary'
          opacity={FONTS_OPACITY}
        >
          Try refining your keywords or removing filters
        </Text>
      </Stack>
    </VStack>
  );
};
